import { createNamespacedHelpers } from 'vuex';
const detectorModelMapper = createNamespacedHelpers('detector/model');
const authMapper = createNamespacedHelpers('global/auth');
import showToast from '@/util/toast';
import { HttpStatusCode } from 'axios';

export default {
	name: 'ModalPreview',

	props: {
		modalId: {
			type: String,
		},
		models: {
			type: Array,
		},
	},

	data() {
		return {
			slide: 0,
			threshold: 0.5,
			searchedModel: '',
			dropdownOpen: false,
			selectedModel: null,
			receiveUserList: [],
			selectedShareModel: '',
			searchedUser: '',
			dropdownUserOpen: false,
			userList: [],
			allowShareData: false,
			appMode: process.env.VUE_APP_MODE,
		};
	},

	computed: {
		...authMapper.mapState(['username']),
		// isVisible: {
		// 	get() {
		// 		return this.$store.state.detector.isVisible;
		// 	},
		// 	set(value) {
		// 		this.$store.dispatch('detector/showFormModal', value);
		// 	},
		// },

		searchedModeslList() {
			const filteredModels = this.models.filter((model) =>
				model.model_name.includes(this.searchedModel)
			);
			if (filteredModels.length === 0) {
				filteredModels.push({
					model_name: this.notFoundModel,
					invalid: true,
				});
			}
			return filteredModels;
		},
		searchedUserList() {
			let selectedUserList = this.receiveUserList.map((user) => user.userName);
			let filteredUserList = this.userList.filter(
				(username) =>
					username.includes(this.searchedUser) && !selectedUserList.includes(username)
			);
			return filteredUserList;
		},
		notFoundModel() {
			return this.$t('notFound');
		},
		searchPlaceholder() {
			return this.$t('modelSearchPlaceholder');
		},
		searchUserPlaceholder() {
			return this.$t('userSearchPlaceholder');
		},
	},

	methods: {
		...authMapper.mapActions(['getUserList']),
		...detectorModelMapper.mapActions([
			'getSharedModelUser',
			'deleteSharedModel',
			'shareModel',
			'getModelOptions',
			'updateModelOptions'
		]),
		/**
		 * Select model
		 * @param {String} selected model name
		 */
		selectModel(modelName) {
			this.$emit('select-model', modelName);
		},

		/**
		 * Select model
		 * @param {String} selected model name
		 */
		deleteModel(model) {
			this.$emit('delete-model', model);
		},

		onFocusInput() {
			document.getElementById('searchInput').focus();
		},

		focusSearchInput() {
			this.dropdownOpen = true;
		},

		focusSearchUserInput() {
			this.dropdownUserOpen = true;
			this.searchedUser = '';
		},

		leaveSearchInput() {
			this.dropdownOpen = false;
		},

		onCloseModal() {
			this.dropdownOpen = false;
			this.$bvModal.hide(this.modalId);
		},

		async onShareModel(model) {
			this.$bvModal.hide(this.modalId);

			// Get share user history
			this.selectedShareModel = model.model_name;
			this.userList = await this.getUserList();
			this.userList = this.userList.filter((user) => user !== this.username);

			let params = {
				model_name: model.model_name,
				user: this.username,
			};
			let receiveUserList = await this.getSharedModelUser(params);
			let receiveUserListUnique = [
				...new Map(receiveUserList.map((m) => [m.receive_user, m])).values(),
			];
			let indexUser = 0;
			for (let user in receiveUserListUnique) {
				if (!this.userList.includes(receiveUserListUnique[user]['receive_user'])) {
					indexUser = receiveUserListUnique.indexOf(
						receiveUserListUnique[user]['receive_user']
					);
					receiveUserListUnique.splice(indexUser, 1);
				}
			}
			this.receiveUserList = receiveUserListUnique.map((user) => {
				return {
					userName: user.receive_user,
					status: user.status,
					shareId: user._id.$oid,
				};
			});
			this.searchedUser = '';
			this.$bvModal.show('share-model-modal');
		},

		onCloseShareModal() {
			this.dropdownUserOpen = false;
			this.allowShareData = false;
			this.$bvModal.hide('share-model-modal');
		},

		async startShareModel() {
			let userList = this.receiveUserList.filter((user) => user.status == 0);
			userList = userList.map((user) => user.userName);
			let body = {
				model_name: this.selectedShareModel,
				request_user: this.username,
				receive_users: userList,
			};
			try {
				await this.shareModel({ body, allowShareData: this.allowShareData });
				this.$bvModal.hide('share-model-modal');
				showToast({
					vueInstance: this,
					type: 'success',
					message: this.$t('shareModalShareSuccess'),
				});
			} catch (err) {
				showToast({
					vueInstance: this,
					type: 'danger',
					message: this.$t('shareModalShareFailed'),
				});
			}
			this.dropdownUserOpen = false;
		},

		onSelectItem(model) {
			let choosenModelName = model.model_name;
			if (model.invalid) {
				return;
			}
			this.models.find((model) => {
				if (model.model_name === choosenModelName) {
					this.selectedModel = this.models.indexOf(model);
					this.dropdownUserOpen = false;
				}
			});
		},

		onSelectUser(username) {
			let body = {
				userName: username,
				status: 0,
			};
			this.searchedUser = username;
			this.receiveUserList.push(body);
			this.dropdownUserOpen = false;
		},

		onClickOutSide() {
			this.dropdownUserOpen = false;
		},

		isModelWaiting(status) {
			return status === 'waiting';
		},

		onClickDeleteShareUser(user, index) {
			if (user.status == 0) {
				this.receiveUserList.splice(index, 1);
			} else {
				let params = {
					share_id: user.shareId,
				};
				this.deleteSharedModel(params);
				this.receiveUserList.splice(index, 1);
			}
		},

		shown() {
			this.$store.dispatch('detector/showFormModal', true);
		},

		hidden() {
			this.onCloseModal();
			this.$store.dispatch('detector/showFormModal', false);
		},

		async onUpdatePrompt(modelId, data) {
			// Update text prompt from given modelId and data
			let params = {
				modelId: modelId,
				dict: {
					"opt": data
				}
			}
			let response = await this.updateModelOptions(params);
			if (response.status != HttpStatusCode.Ok) {
				showToast({
					vueInstance: this,
					type: 'error',
					message: this.$t('fail'),
				});
    
        return;
			}
			showToast({
				vueInstance: this,
				type: 'success',
				message: this.$t('success'),
			});
		},

	},
};
